import { IBindingAction } from '../models/callback';

export const handleEnter = (event: KeyboardEvent | React.KeyboardEvent<HTMLInputElement>, onEnter: IBindingAction) => {
  if (event.key === 'Enter') {
    onEnter();
  }
};
